import type { Client } from '@peloton/api/utils';
import { pipeData } from '@peloton/api/utils';
import { toPeloton } from './mappers';

const toPelotonUrl = (id: string) => `/api/peloton/${id}`;

export const fetchPeloton = (api: Client, pelotonId: string) =>
  api.get(toPelotonUrl(pelotonId)).then(pipeData(toPeloton));
